var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpopBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 43,
    viewBox: "0 0 438 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Selection #1",
    fill: "white",
    stroke: "#ffc005",
    strokeWidth: 20,
    d: "M 0.00,0.00          C 0.00,0.00 0.00,440.00 0.00,440.00          0.00,440.00 137.00,440.00 137.00,440.00          139.44,440.00 142.73,439.87 145.00,440.74          148.80,442.20 157.88,452.32 161.28,455.72          161.28,455.72 198.84,493.07 198.84,493.07          198.84,493.07 213.00,507.27 213.00,507.27          214.39,508.55 217.03,511.41 219.00,511.41          220.97,511.41 223.61,508.55 225.00,507.27          225.00,507.27 239.28,493.07 239.28,493.07          239.28,493.07 276.72,455.84 276.72,455.84          276.72,455.84 284.72,447.83 284.72,447.83          291.53,440.84 290.97,440.02 301.00,440.00          301.00,440.00 438.00,440.00 438.00,440.00          438.00,440.00 438.00,0.00 438.00,0.00          438.00,0.00 0.00,0.00 0.00,0.00 Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "triangle",
    points: "218,40 38,380 400,380",
    fill: "#ffc005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpopBox);
export default __webpack_public_path__ + "static/media/spop_box.092ad1bc0f73061001f1c97ccdfad0c1.svg";
export { ForwardRef as ReactComponent };